import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import OEFNElement, {OEFNElementType} from '../../elements/oe-flow-nav-elements';

export default class OEFlowNavElementCollection extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            texts:  {}
        };

        this.updateLanguage = this.updateLanguage.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(!OEToolbox.shallowEqual(nextProps.elements, this.props.elements, true))  {
            this.updateLanguage(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    elementsTexts(elements)   {
        if(!Array.isArray(elements)) return {};

        let si = this.oe.sharedInterface;

        let texts = {};

        elements.forEach((element, i) => {
            if(element.titleId)     texts[element.titleId] = si.getLocalizedStringEnc(element.titleId);
            if(element.labelId)     texts[element.labelId] = si.getLocalizedStringEnc(element.labelId);
            if(element.textId)      texts[element.textId] = si.getLocalizedStringEnc(element.textId);

            texts = Object.assign(texts, this.elementsTexts(element.elements));
        });

        return texts;
    }

    updateLanguage(props)   {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        let texts = this.elementsTexts(props.elements);
        this.setState({texts: texts});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    resolveText(textId, text)  {
        if(!textId) return text;
        let text_ = this.state.texts[textId];
        return text_ !== undefined ? text_ : text;
    }

    renderElements(elements) {
        if(!Array.isArray(elements)) return undefined;

        let ret = [];

        elements.forEach((element, index) => {
            let FNElement = OEFNElement.elementForType(element.type);
            if(!FNElement)  return;

            let {elements: subElements, titleId, title, labelId, label, textId, text, ...rest} = element;

            title = this.resolveText(titleId, title);
            label = this.resolveText(labelId, label);
            text = this.resolveText(textId, text);

            let element_ = (
                <FNElement
                    key={index}
                    {...rest}
                    title={title}
                    label={label}
                    text={text}
                >
                    {this.renderElements(subElements)}
                </FNElement>
            );

            ret.push(element_);
        });

        return ret;
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div
                    className={'flow-nav-element-collection ' + this.props.className}
                    style={this.props.style}
                >
                    {this.renderElements(this.props.elements)}
                </div>
            </React.Fragment>
        );
    }
}

OEFlowNavElementCollection.defaultProps = {
    moduleId:           '',
    className:          ''
};

OEFlowNavElementCollection.propTypes = {
    moduleId:           PropTypes.string,
    elements:    PropTypes.arrayOf(PropTypes.shape({
        type:           PropTypes.oneOf(OEFNElementType.all)
    }))
};